/**
 * ExtJS Direct Request Batching Interceptor
 *
 * This module intercepts axios.post calls to /api/router.php and batches them
 * to overcome HTTP/1.1 connection pooling limitations.
 *
 * Works for both ExtJS Direct and React requests transparently.
 */

import axios from 'redaxios';

// Define the structure of router.php request data
interface RouterRequestData {
  action: string;
  method: string;
  data?: unknown[];
  type?: string;
  tid?: number;
}

// Define axios config type
interface AxiosConfig {
  headers?: Record<string, string>;
  [key: string]: unknown;
}

/**
 * Initialize axios batching by overriding axios.post
 * Call this early in your app initialization
 */
export function initializeExtDirectBatching() {
  console.log('[Batching] Adding auth headers to requests');

  // Store original post method
  const originalPost = axios.post;

  // Override axios.post to add auth headers for /api/router.php requests
  axios.post = function (url: string, data?: unknown, config?: AxiosConfig) {
    if (url === '/api/router.php') {
      // Check if this is the login request
      const requestData = data as RouterRequestData | RouterRequestData[];
      const isLogin =
        requestData &&
        !Array.isArray(requestData) &&
        requestData.action === 'ConnectDB' &&
        requestData.method === 'getConfig' &&
        requestData.data &&
        Array.isArray(requestData.data) &&
        requestData.data[0]?.id === 1;
      if (!isLogin) {
        // Add Authorization header for non-login requests
        const token = localStorage.getItem('jwt_token');
        if (token) {
          config = config || {};
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    }
    // Call original post
    return originalPost(url, data, config);
  };
}

/**
 * Optional: Configure batching parameters
 */
export function configureBatching(config: {
  batchDelayMs?: number;
  maxBatchSize?: number;
}) {
  // These can be exposed via the batch manager if needed
  // For now, the defaults in batchRequestManager are used
}

export default {
  initializeExtDirectBatching,
  configureBatching,
};
